import React from 'react';
import styled from 'styled-components';
import { flexCenterVertical } from '../../styles/mixins';
import { vars } from '../../theme';
import HBSidePanel from './HBSidePanel';
import { SIDE_PANEL_SCROLLED_CLASS } from './HBSidePanel.consts';

export interface HBSidePanelHeaderProps {
    /** CSS class applied to the root element. */
    className?: string;
    /** Additional controls rendered to the right of the left section (e.g. `HBSidePanel.ExpandButton`). */
    extraControls?: React.ReactNode;
    /** Content rendered in the left slot of the header (e.g. a back button or client avatar). */
    leftSection?: React.ReactNode;
    testId?: string;
}

const HBSidePanelHeader: React.FC<HBSidePanelHeaderProps> = ({
    className,
    extraControls,
    leftSection,
    testId = 'side-panel-header'
}) => {
    return (
        <HeaderContainer className={className} data-testid={testId}>
            <LeftSection>{leftSection}</LeftSection>

            {extraControls && <MiddleSection>{extraControls}</MiddleSection>}

            <RightSection>
                <HBSidePanel.CloseButton />
            </RightSection>
        </HeaderContainer>
    );
};

export default HBSidePanelHeader;

// -------------------------------- Styles -------------------------------- //
const HeaderContainer = styled.header`
    ${flexCenterVertical};
    justify-content: space-between;
    height: 62px;
    padding: 16px;
    background-color: ${vars.colors.surface.container};
    border-bottom: 1px solid transparent;
    .${SIDE_PANEL_SCROLLED_CLASS} & {
        border-bottom-color: ${vars.colors.stroke.secondary};
    }
`;

const LeftSection = styled.div`
    ${flexCenterVertical};
    gap: 12px;
    min-width: 30px;
    padding-right: 16px;
`;

const MiddleSection = styled.div`
    flex: 1;
    ${flexCenterVertical};
    min-width: 0;
    padding-left: 16px;
    padding-right: 8px;
    justify-content: end;
`;

const RightSection = styled.div`
    ${flexCenterVertical};
    padding-left: 8px;
    border-left: 1px solid ${vars.colors.stroke.secondary};
`;
